import { useState } from 'react';
import { CTAModal } from './CTAModal';

export function StepsSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const steps = [
    {
      number: '1',
      title: 'お問い合わせ',
      description: 'お電話・LINE・フォームからお気軽にお問い合わせください。ご希望の日時をお伺いします。',
      icon: 'ri-phone-line',
      color: 'bg-blue-500'
    },
    {
      number: '2',
      title: '無料体験授業',
      description: '実際の授業を60分間体験。お子様の学力を確認し、最適な学習プランをご提案します。',
      icon: 'ri-book-open-line',
      color: 'bg-green-500'
    },
    {
      number: '3',
      title: 'ご入会・授業開始',
      description: 'ご納得いただけましたらご入会。すぐに授業を開始し、成績アップを目指します。',
      icon: 'ri-rocket-line',
      color: 'bg-orange-500'
    }
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4">
            無料体験までの流れ
          </h2>
          <p className="text-sm md:text-base text-gray-600">
            たった3ステップで簡単スタート
          </p>
        </div>

        <div className="space-y-6 mb-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex flex-col md:flex-row items-start md:items-center gap-6 bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg p-6 md:p-8 border border-gray-200">
                <div className={`w-16 h-16 flex items-center justify-center ${step.color} rounded-xl shadow-md flex-shrink-0`}>
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-4xl font-black text-gray-200">
                      STEP {step.number}
                    </span>
                    <h3 className="text-xl md:text-2xl font-bold text-gray-800">
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
              
              {index < steps.length - 1 && (
                <div className="flex justify-center my-4">
                  <i className="ri-arrow-down-line text-3xl text-blue-600"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-2xl p-8 text-center text-white shadow-xl">
          <h3 className="text-2xl md:text-3xl font-black mb-4">
            まずは無料体験から
          </h3>
          <p className="text-sm md:text-base mb-6 leading-relaxed">
            お子様に合うかどうか、実際の授業を体験してからご判断ください。<br />
            無理な勧誘は一切いたしません。
          </p>
          <button 
            onClick={() => setIsModalOpen(true)}
            className="bg-white hover:bg-gray-100 text-orange-600 font-bold text-base md:text-lg px-8 py-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-check-line mr-2"></i>
            今すぐ無料体験を申し込む
          </button>
        </div>
      </div>

      <CTAModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        type="trial"
      />
    </section>
  );
}
